import { Typography } from "@mui/material";

export type CheckItem = {
  bold?: string;
  text: string;
};

type CheckItemsListProps = Readonly<{
  checkItems: CheckItem[];
  t: (key: string) => string;
}>;

export function CheckItemsList({ checkItems, t }: CheckItemsListProps) {
  if (checkItems.length === 0) {
    return null;
  }

  return (
    <Typography variant="bodyMedium" component="div">
      <ul style={{ margin: 0, paddingLeft: "20px" }}>
        {checkItems.map((item, index) => (
          <li key={`${index}-${item.text}`}>
            {item.bold && <strong>{t(item.bold)} </strong>}
            {t(item.text)}
          </li>
        ))}
      </ul>
    </Typography>
  );
}
